export default {"src":"/_next/static/media/prideBet.51f6c45d.svg","height":200,"width":400,"blurWidth":0,"blurHeight":0};